export const managementTokenStorageKey = 'cc_token';
export const managementAuthRequiredEvent = 'cc:management-auth-required';

export type ManagementTokenStorage = Pick<Storage, 'getItem' | 'setItem'> & Partial<Pick<Storage, 'removeItem'>>;

export type ManagementAuthRequiredDetail = {
  status: number;
  message: string;
  path: string;
};

export function readManagementToken(storage: ManagementTokenStorage | null = getManagementTokenStorage()) {
  const token = storage?.getItem(managementTokenStorageKey)?.trim() ?? '';
  return token.length > 0 ? token : null;
}

export function persistManagementToken(token: string, storage: ManagementTokenStorage | null = getManagementTokenStorage()) {
  const normalized = token.trim();
  if (!normalized) return null;
  storage?.setItem(managementTokenStorageKey, normalized);
  return normalized;
}

export function clearManagementToken(storage: ManagementTokenStorage | null = getManagementTokenStorage()) {
  storage?.removeItem?.(managementTokenStorageKey);
}

export function dispatchManagementAuthRequired(detail: ManagementAuthRequiredDetail) {
  if (typeof window === 'undefined' || typeof window.dispatchEvent !== 'function') return;

  if (typeof CustomEvent === 'function') {
    window.dispatchEvent(new CustomEvent<ManagementAuthRequiredDetail>(managementAuthRequiredEvent, { detail }));
    return;
  }

  const event = new Event(managementAuthRequiredEvent) as Event & { detail: ManagementAuthRequiredDetail };
  Object.defineProperty(event, 'detail', { value: detail });
  window.dispatchEvent(event);
}

function getManagementTokenStorage(): ManagementTokenStorage | null {
  if (typeof localStorage !== 'undefined') return localStorage;
  if (typeof window !== 'undefined') return window.localStorage;
  return null;
}
